
export default function About() {
  return (
    <section id="nosotros" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl sm:text-6xl font-light text-gray-900 mb-6">Tu proveedor industrial de confianza</h2>
          <div className="w-20 h-0.5 bg-royal-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/b33cef93078bf398fa74d36dbc4f22d5.jpg" 
              alt="HIPERCLEAN Instalaciones" 
              className="w-full h-96 object-cover object-top rounded-lg shadow-2xl"
            />
          </div>

          <div className="space-y-8">
            <h3 className="text-3xl font-light text-gray-900">Soluciones industriales para empresas exigentes</h3>
            <p className="text-gray-700 text-base leading-relaxed">
              En <strong>HIPERCLEAN DE AGUASCALIENTES</strong>, somos un proveedor especializado en suministros de limpieza, químicos industriales e insumos higiénicos para empresas, industrias y negocios en la región centro de México.
            </p>
            <p className="text-gray-700 text-base leading-relaxed">
              Con&nbsp; mas de 15años de experiencia atendiendo sectores manufactureros, de salud, hotelería y gobierno, nos hemos consolidado como un socio estratégico que entiende las necesidades de operación continua, cumplimiento normativo y optimización de costos.
            </p>
            <p className="text-gray-700 text-base leading-relaxed">
              Nuestro compromiso es ofrecer <strong>calidad certificada</strong>, <strong>cumplimiento en tiempos de entrega</strong> y <strong>servicio profesional</strong> que se adapta a los requerimientos específicos de cada industria.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              <div className="bg-gray-50 rounded-lg p-8 border border-gray-200">
                <div className="w-14 h-14 bg-royal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-target-line text-royal-600 text-2xl"></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Nuestra Misión</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Brindar soluciones eficientes en limpieza e insumos industriales con productos certificados y servicio profesional.</p>
              </div>

              <div className="bg-gray-50 rounded-lg p-8 border border-gray-200">
                <div className="w-14 h-14 bg-navy-100 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-eye-line text-navy-600 text-2xl"></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3">Nuestra Visión</h4>
                <p className="text-gray-600 text-sm leading-relaxed">Ser un proveedor líder en la región centro del país, reconocido por confiabilidad y excelencia operativa.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-royal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-royal-600 text-3xl"></i>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">Calidad</h4>
            <p className="text-gray-600 text-sm">Productos certificados y cumplimiento normativo</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-navy-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-navy-600 text-3xl"></i>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">Cumplimiento</h4>
            <p className="text-gray-600 text-sm">Entregas puntuales y abastecimiento continuo</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-royal-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-royal-600 text-3xl"></i>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">Servicio</h4>
            <p className="text-gray-600 text-sm">Atención profesional y asesoría técnica especializada</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-navy-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-hand-heart-line text-navy-600 text-3xl"></i>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-2">Confiabilidad</h4>
            <p className="text-gray-600 text-sm">Socio estratégico para tu operación industrial</p>
          </div>
        </div>
      </div>
    </section>
  );
}
